import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { coordinationEndpoints } from '@/modules/coordination/constants';

import { coordinationQueryKeys } from './queryKeys';

export const useCoordinationMeetingQuery = (meetingId: string | undefined) => {
  return useQuery({
    queryKey: meetingId ? coordinationQueryKeys.meeting(meetingId) : [],
    queryFn: meetingId
      ? async () => {
          const { data } = await fetchClient.GET(
            coordinationEndpoints.meetingById,
            {
              params: { path: { meetingId } },
            },
          );

          return data;
        }
      : skipToken,
  });
};
